import {
  Box,
  Button,
  Center,
  Container,
  Flex,
  Heading,
  Image,
  ListItem,
  OrderedList,
  Text,
  UnorderedList,
} from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import NavbarOpen from '../NavLinks/NavbarOpen'

const ZoomDisconnectScreen = () => {
  const steps = [
    'Login to your Zoom Account and navigate to the Zoom App Marketplace.',
    'Click Manage >> Added Apps or search for the ’Arrowhead’ app.',
    'Click the ’Arrowhead’ app.',
    'Click Remove',
  ]
  return (
    <Container
      bg='brandBackground'
      maxW='full'
      px='131px'
      pt='48px'
      h='100vh'
    >
      <Box
        left='0'
        top='0'
        position='absolute'
      >
        <NavbarOpen />
      </Box>
      <Flex
        justify='center'
        align='center'
        h='100%'
      >
        <Box>
          <Center align='center'>
            <Flex
              direction='column'
              mt='-150px'
            >
              {' '}
              <Heading
                fontSize='5xl'
                color='black'
                px='150px'
                lineHeight='1'
                mb='4'
              >
                {' '}
                Disconnect Zoom
              </Heading>
              <Text
                color='black'
                mt='42px'
                mb='20px'
                alignSelf='center'
              >
                Are you sure?
              </Text>
              <Text
                color='black'
                alignSelf='center'
                mb='42px'
              >
                You won’t be able to capture any of your Zoom conversations onto
                Arrowhead!
              </Text>
              <Heading
                color='black'
                fontSize='1rem'
                mb='5px'
                alignSelf='flex-start'
              >
                How to remove Zoom:
              </Heading>
              <OrderedList alignSelf='flex-start'>
                {steps.map((step, id) => (
                  <ListItem
                    key={id}
                    color='black'
                    textAlign='left'
                  >
                    {step}
                  </ListItem>
                ))}
              </OrderedList>
              <Heading
                color='black'
                fontSize='1rem'
                mb='5px'
                mt='42px'
                alignSelf='flex-start'
              >
                Note:
              </Heading>
              <UnorderedList alignSelf='flex-start'>
                <ListItem
                  color='black'
                  textAlign='left'
                >
                  We will delete all your data if you choose to disconnect your
                  Zoom account
                </ListItem>
              </UnorderedList>
            </Flex>
          </Center>
        </Box>
      </Flex>
    </Container>
  )
}

export default ZoomDisconnectScreen
